import PropTypes from 'prop-types';
import React from 'react';
import { Head } from '../Head';
import { motion } from 'framer-motion';

export const ContentLayout = ({
  children,
  title,
  titleButton,
  subTitle,
  end = null,
  breadcrumbs,
}) => {
  return (
    <>
      <Head title={title} />
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <div className="py-6 ml-[calc(20%+2.5rem)] px-6 mr-[2%] lg:px-8">
          <div className="bg-white dark:bg-gray-900 rounded-3xl shadow-md mb-4 p-6">
            {breadcrumbs && <div className="mb-2">{breadcrumbs}</div>}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
              <div>
                <div className="flex flex-row items-center space-x-3">
                  <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
                    {title}
                  </h1>
                  {titleButton}
                </div>
                {subTitle && (
                  <p className="text-lg text-gray-600 dark:text-gray-300 mt-1">
                    {subTitle}
                  </p>
                )}
              </div>
              {end && <div className="flex-shrink-0">{end}</div>}
            </div>
          </div>
          <div>{children}</div>
        </div>
      </motion.div>
    </>
  );
};

ContentLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  end: PropTypes.node,
  breadcrumbs: PropTypes.node,
};
